import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NuevoDocumenentoRoutingModule } from './nuevo-documento-routing.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SelectModule } from 'src/app/filtros/components/select/select.module';
import { NuevoDocumentoComponent } from './nuevo-documento.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { MatCheckboxModule } from '@angular/material/checkbox';





@NgModule({
  declarations: [NuevoDocumentoComponent],
  imports: [
    CommonModule,
    NuevoDocumenentoRoutingModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatTableModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSnackBarModule,
    MatPaginatorModule,
    SelectModule,
    AngularEditorModule,
    MatCheckboxModule
  ]
})
export class NuevoDocumentoModule { }
